import { render, staticRenderFns } from "./IconSvgGift.vue?vue&type=template&id=357a6ee0&scoped=true&"
import script from "./IconSvgGift.vue?vue&type=script&lang=js&"
export * from "./IconSvgGift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357a6ee0",
  null
  
)

export default component.exports